import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='bg-dark footer d-flex justify-content-center text-center'>
           <div className='text-white py-5'>
               <h2>World Car House</h2>
           <h1>Quick Support & Update</h1>
           <p>© WorldCar House 2021, All Rights Reserved</p>
           </div>
   
        </div>
    );
};

export default Footer;